import { call, put, select } from "redux-saga/effects";

import firebase from "../services/firebase";
import * as actions from "../constants/actions";
// import * as actionTypes from "../constants/actionTypes"
import { getUserId, getModelById } from "../selectors";

export function* createModelExport({ payload }) {
  const { error, modelExport } = yield call(
    firebase.modelExport.create,
    payload
  );

  if (error) {
    // handle error
    return;
  }

  yield put(actions.setModelExport({ modelExport }));
}

export function* updateModelExport({ payload }) {
  const { id, params } = payload;
  const model = yield select(getModelById, id);

  const { error } = yield call(firebase.model.update, id, {
    ...model,
    ...params
  });

  if (error) {
    // TODO: handle error in UI
  } else {
    const userId = yield select(getUserId);
    const models = yield call(firebase.model.fetchAll, { userId });
    yield put(actions.setModels({ models }));
  }
}

export function* fetchModels() {
  const userId = yield select(getUserId);
  const models = yield call(firebase.model.fetchAll, { userId });

  yield put(actions.setModels({ models }));
}

export function* fetchModel({ payload }) {
  const { id } = payload;
  const model = yield call(firebase.model.fetch, { id });

  if (model) {
    yield put(actions.setModel({ id, model }));
  } else {
    yield put(actions.modelNotFound({ id }));
  }
}

export function* fetchModelExport({ payload }) {
  const model = yield call(firebase.model.fetch, { id: payload.token });

  if (model) {
    yield put(actions.setModel({ id: model.id, model }));
  } else {
    yield put(actions.modelNotFound({ id: payload.token }));
  }
}



// WEBPACK FOOTER //
// ./src/sagas/modelExports.js